import { Component, Input, OnInit, AfterContentChecked } from '@angular/core';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { DashboardCenter } from 'src/app/models/dashboard-models/dasboard-center.model';
import { MapTypeStyle } from '@agm/core';

@Component({
  selector: 'app-dashboard-devices-locations-card',
  templateUrl: './dashboard-devices-locations-card.component.html',
  styleUrls: ['./dashboard-devices-locations-card.component.scss']
})
export class DashboardDevicesLocationsCardComponent implements OnInit, AfterContentChecked {

  @Input() data: Array<DashboardCenter>;
  @Input() title;
  first;

  getCentersSubscription: Subscription;

  labelOptions = {
    color: 'white',
    background: 'black',
    fontFamily: '',
    fontSize: '14px',
    fontWeight: 'bold',
    text: 'some text'
  };
  icon = {
    url: 'assets/icons/map_marker.svg',
    scaledSize: {height: 40, width: 40},
    labelOrigin: {x: 20, y: -20 } };
  map_style = [
    {
        'featureType': 'administrative',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#444444'
            }
        ]
    },
    {
        'featureType': 'landscape',
        'elementType': 'all',
        'stylers': [
            {
                'color': '#f2f2f2'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'all',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'all',
        'stylers': [
            {
                'saturation': -100
            },
            {
                'lightness': 45
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'all',
        'stylers': [
            {
                'visibility': 'simplified'
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'transit',
        'elementType': 'all',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'all',
        'stylers': [
            {
                'color': '#46bcec'
            },
            {
                'visibility': 'on'
            }
        ]
    }
];

  Styles: MapTypeStyle[] = [];

  constructor(
    private centersCentersService: CentersCentersService,
    private snackbarService: SnackBarService
  ) { }

  ngOnInit() {
    this.map_style.forEach((style: any) => {
      this.Styles.push(style);
    });
    console.log(JSON.stringify(this.data));
  }

  ngAfterContentChecked(): void {
    if ((null !== this.data) && (undefined !== this.data)) {
        this.first = this.data[0];
    }
  }

}
